import './style.sass'
import 'reflect-metadata'

import Icon from '@/components/Icon.vue'
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import VueTyped from 'vue-typed-js'

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueTyped)
Vue.use(VueMasonry)
Vue.component('Icon', Icon)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
